import theme from "../../theme";
import type { LanguageSelectStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<LanguageSelectStyles, SxProps<Theme>> => {
  return {
    root: {
      m: theme.spacing(1),
      position: "absolute",
      right: 10,
      top: 0,
      zIndex: 1,
    },

    initial: {
      position: "absolute",
      top: 0,
      width: "100%",
      height: "150%",
      backgroundColor: "#FFF",
      zIndex: 2,
    },

    languageBox: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 2,
      mt: "3%",
    },

    button: {
      width: "55%",
      // fontSize: 30,
      color: "black",
      "@media (min-width:120px)": {
        fontSize: 14,
        // color: "yellow",
        fontWeight: "bold",
      },
      "@media (min-width:300px)": {
        fontSize: 18,
        // color: "purple",
        fontWeight: "bold",
      },
      "@media (min-width:400px)": {
        fontSize: 22,
        // color: "brown",
        fontWeight: "bold",
      },
      "@media (min-width:600px)": {
        fontSize: 30,
        // color: "red",
      },
      "@media (min-width:800px)": {
        fontSize: 24,
        // color: "orange",
      },
      "@media (min-width:1000px)": {
        fontSize: 24,
        // color: "violet",
      },
      "@media (min-width:1280px)": {
        fontSize: 24,
        // color: "green",
      },
    },
  };
};

export default getStyles;
